import { createConsts, createActions } from '../../utils/redux';

const supportedActions = ['OPEN_VIEWER', 'CLOSE'];

export const consts = createConsts('ui', 'imageViewer', ...supportedActions);
export const actions = createActions(consts);

const initialState = {
  opened: false,
  src: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case consts.OPEN_VIEWER:
      return { opened: true, src: action.payload.src };
    case consts.CLOSE:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/ui/imageViewer.js